var kefu = function kefu() {
  //   setTimeout(()=>{
  // let scriptId = "script_floatbutton_" + 3;
  //         let script = document.getElementById(scriptId);
  //         if (script) {
  //           document.body.removeChild(script);
  //         }
  //         script = document.createElement("script");
  //         script.id = scriptId;
  //         document.body.append(script);
  //         script.innerHTML = `(function(a, b, c, d, e, j, s) {\na[d] = a[d] || function() {\n(a[d].a = a[d].a || []).push(arguments)\n};\nj = b.createElement(c),\ns = b.getElementsByTagName(c)[0];\nj.async = true;\nj.charset = 'UTF-8';\nj.src = 'https://static.meiqia.com/widget/loader.js';\ns.parentNode.insertBefore(j, s);\n})(window, document, 'script', '_MEIQIA');\n_MEIQIA('entId', 'ed70e1d176a41fb5929ada2b6c760b78');\n_MEIQIA("showPanel");`;
  //   },500)
  // (function(m, ei, q, i, a, j, s) {
  //         m[i] = m[i] || function() {
  //             (m[i].a = m[i].a || []).push(arguments)
  //         };
  //         j = ei.createElement(q),
  //             s = ei.getElementsByTagName(q)[0];
  //         j.async = true;
  //         j.charset = 'UTF-8';
  //         j.src = 'https://visitor-static.meiqia.com/fe-widget-visitor/loader.js';
  //         s.parentNode.insertBefore(j, s);
  //     })(window, document, 'script', '_MEIQIA');
  //     _MEIQIA('entId', '0326e704d61ea2ba721c6ab65686097d');
  //     // 初始化成功时的回调
  //     _MEIQIA('allSet');
  setTimeout(function () {
    var option = {
      openUrl: "https://testchat.qbbystudy.com",
      // 打开客服聊天框的地址，即：部署后台管理系统的地址，若未填写，则自动获取当前服务器的地址
      token: "c83c12466e09bf46b09e3c38b686b4af",
      // token,与后台交互的凭证
      kefuid: '14',
      //默认为空自动对接客服，可填写指定客服ID
      isShowTip: true,
      // 初始化成功后，界面右下角会自动创建 “联系客服按钮”， 如无需默认展示，则填写false即可,默认为true
      mobileIcon: '',
      //  手机端悬浮客服图片
      pcIcon: '',
      // pc端悬浮客服图片
      windowStyle: 'center' //默认空 右下角小弹窗， center 普通中间弹窗样式

    };
    window.canCustomerServer = new initCustomerServer(option); //实例化加载客服组建

    window.canCustomerServer.init(); // 调用打开客服弹窗的方法，如果isShowTip为false，就使用这个函数，当然也可以使用A链接
    // canCustomerServer.getCustomeServer();
  }, 3000);
};

export default kefu;